import { render } from "./categorySelector.vue?vue&type=template&id=cf186744&scoped=true&ts=true"
import script from "./categorySelector.vue?vue&type=script&lang=ts"
export * from "./categorySelector.vue?vue&type=script&lang=ts"

import "./categorySelector.vue?vue&type=style&index=0&id=cf186744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf186744"]])

export default __exports__